module.exports = __webpack_public_path__ + "img/1479227419.e0ccf72c.jpg";